export default __webpack_public_path__ + "static/media/602.217ed34d.png";